import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog";
import { Reveal, Eyebrow } from "./Reveal";
import { GALLERY } from "../../data/site";

export const Gallery = () => {
  const [active, setActive] = useState(null);

  return (
    <section id="gallery" data-testid="gallery-section" className="section bg-[var(--sand)]">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <Reveal className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <div>
            <Eyebrow>From our sites</Eyebrow>
            <h2 className="section-title mt-4">Site gallery</h2>
          </div>
          <p className="max-w-md text-[var(--muted-ink)]">Photos taken on our own sites, during and after construction. Tap any photo to enlarge it.</p>
        </Reveal>
        <div className="mt-14 columns-1 gap-4 sm:columns-2 lg:columns-3">
          {GALLERY.map((g, i) => (
            <button
              key={g.src}
              type="button"
              data-testid={`gallery-item-${i}`}
              onClick={() => setActive(g)}
              className="group relative mb-4 block w-full overflow-hidden break-inside-avoid"
            >
              <img src={g.src} alt={g.alt} loading="lazy" className="w-full transition-transform duration-700 group-hover:scale-105" />
              <span className="absolute inset-x-0 bottom-0 translate-y-2 bg-gradient-to-t from-black/80 to-transparent p-4 pt-12 text-left opacity-0 transition-[opacity,transform] duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                <span className="block font-mono text-[10px] uppercase tracking-wider text-[var(--rust-light)]">{g.group}</span>
                <span className="mt-1 block text-sm text-white">{g.alt}</span>
              </span>
            </button>
          ))}
        </div>
      </div>
      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent data-testid="gallery-lightbox" className="max-w-5xl border-0 bg-black p-0 [&>button]:rounded-full [&>button]:bg-white [&>button]:p-1 [&>button]:opacity-100">
          <DialogTitle className="sr-only">{active?.alt}</DialogTitle>
          {active && (
            <figure>
              <img src={active.src} alt={active.alt} className="max-h-[80vh] w-full object-contain" />
              <figcaption className="p-4 text-sm text-white/80">{active.alt}</figcaption>
            </figure>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};
